import React from 'react';
import useGradebookExport from '../hooks/useGradebookExport';
import './GradeExport.css';

const GradeExport = () => {
  const {
    canExport,
    loadingStudents,
    loadingGrades,
    loading,
    error,
    hasStudents,
    hasColumns,
    downloadGradebook,
  } = useGradebookExport();

  if (!canExport) {
    return (
      <div className="grade-export">
        <p>You do not have permission to export grades for this course.</p>
      </div>
    );
  }

  const isDownloadDisabled = loading || !hasStudents || !hasColumns;

  return (
    <div className="grade-export">
      <h3>Grade Export</h3>
      <p className="grade-export__description">
        Download the current gradebook as an Excel spreadsheet.
      </p>

      {error && <div className="grade-export__error">{error}</div>}

      <button
        type="button"
        className="grade-export__button"
        onClick={downloadGradebook}
        disabled={isDownloadDisabled}
      >
        {loadingStudents || loadingGrades ? 'Preparing…' : 'Download grades (.xlsx)'}
      </button>

      {!hasStudents && !loadingStudents && !error && (
        <p className="grade-export__hint">No student data available yet for this course.</p>
      )}
    </div>
  );
};

export default GradeExport;
